import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { AxiosError } from 'axios';
import { sessionViewSelectors } from '../../../../../../redux/views/session-view/session/slice';
import { RootState } from '../../../../../../redux/store';
import {
  launchPanelApi,
  useGetLaunchPanelQuery,
} from '../../../../../../redux/views/session-view/launch-panel/api';
import { determineShouldSkip } from './utils/utils';
import { LaunchPanelTabContent } from './index';

const LaunchPanelTabContentContainer = ({
  sessionActiveTab,
  sessionUid,
  versionUid,
}: LaunchPanelTabContentContainerProps): ReactElement => {
  const { useQueryState } = launchPanelApi.endpoints.getLaunchPanel;
  const { data: existingData } = useQueryState({
    sessionUid,
    versionUid,
  });

  const { data, isLoading, isError, isFetching, refetch, error } =
    useGetLaunchPanelQuery(
      { sessionUid, versionUid },
      {
        skip: determineShouldSkip({ existingData, sessionActiveTab }),
      },
    );

  return (
    <LaunchPanelTabContent
      error={error as AxiosError}
      sessionActiveTab={sessionActiveTab}
      isError={isError}
      isLoading={isLoading}
      isFetching={isFetching}
      embeddedAppUrl={data?.url || existingData?.url}
      refetch={refetch}
    />
  );
};

type ConnectedLaunchPanelTabContentOwnProps = {
  sessionUid: string;
  versionUid: string;
};

const mapStateToProps = (
  state: RootState,
  ownProps: ConnectedLaunchPanelTabContentOwnProps,
) => ({
  sessionActiveTab: sessionViewSelectors.getSessionActiveTab(state),
  ...ownProps,
});

type LaunchPanelTabContentContainerProps = ReturnType<typeof mapStateToProps>;

export const ConnectedLaunchPanelTabContent = connect(mapStateToProps)(
  LaunchPanelTabContentContainer,
);
